module.exports = __webpack_public_path__ + "static/media/logo25bg.cfc77cd7.png";